"use client";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="cs">
      <body
        style={{
          fontFamily: "Segoe UI, system-ui, Arial, sans-serif",
          margin: 0,
          padding: "4rem 1.5rem",
          color: "#0d1f33",
          background: "#f7f6f3",
        }}
      >
        <main style={{ maxWidth: "40rem", margin: "0 auto" }}>
          <h1 style={{ fontSize: "1.75rem", marginBottom: "1rem" }}>
            Něco se pokazilo
          </h1>
          <p style={{ lineHeight: 1.6, marginBottom: "1.5rem" }}>
            Omlouváme se, při načítání stránky došlo k neočekávané chybě.
            Zkuste to prosím znovu, případně nás kontaktujte telefonicky na
            +420 553 612 851 nebo e-mailem na poradcegrafova@volny.cz.
          </p>
          <button
            type="button"
            onClick={() => reset()}
            style={{
              background: "#16304c",
              color: "#ffffff",
              border: "none",
              borderRadius: "0.375rem",
              padding: "0.75rem 1.25rem",
              fontSize: "0.95rem",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Zkusit znovu
          </button>
        </main>
      </body>
    </html>
  );
}
